/*
export const baseUrl = 'http://localhost:3000'
*/

export const baseUrl = 'https://env-1309022.jcloud-ver-jpc.ik-server.com'
